import baseStoreDefaults from '../2w37mf1yxr-1/config.js';

function updateCallback() {
  const pagination = window.document.querySelector('.cm_SearchHeader .cm_pagination');

  // handle case, when SearchHeader doesn't contain pagination
  window.document
    .querySelector('.cm_SearchHeader .cm_sort')
    ?.classList.toggle('without-pagination', !pagination);
}

function getLocalPreselection(pageType, defaults) {
  if (window.location.pathname.startsWith('/sales')) {
    return [{ field: 'on_sale', term: 'True' }];
  }

  return defaults.getter(pageType);
}

// EN theme: gold/silver/bronze + logged-in non-Retail see NET; Forum/Friendly/Community see gross
function isGrossRetailGroup() {
  const groupName = getCustomerGroupName();
  return groupName.includes('forum') || groupName.includes('friendly') || groupName.includes('community');
}

const getLang = () => localStorage.getItem('cm_lang') || 'en';

function getCustomerGroupId() {
  return window.Convermax.BigCommerce?.getCustomerGroupId() || '1'; // Retail
}

function getCustomerGroupName() {
  return (
    window.jsContext?.customer?.customer_group_name ||
    window.document.querySelector('body')?.getAttribute('data-customer-group') ||
    ''
  ).toLowerCase();
}

function mapCountryNameToCode(countryStr) {
  switch (countryStr) {
    case 'Germany':
    case 'Deutschland':
    case 'Niemcy':
      return 'DE';
    case 'Poland':
    case 'Polen':
    case 'Polska':
      return 'PL';
    case 'Switzerland':
    case 'Schweiz':
    case 'Suisse':
    case 'Svizzera':
      return 'CH';
    case 'Norway':
    case 'Norwegen':
      return 'NO';
    default:
      // Theme mapCountryNameToCode: unknown names use DE. ISO codes (checkout) stay as-is.
      return countryStr?.length === 2 ? countryStr.toUpperCase() : 'DE';
  }
}

function getCountry() {
  const rawCountry =
    window.Convermax.country ||
    window.jsContext?.customerDefaultCountry ||
    localStorage.getItem('cutomer_default_country');

  if (!rawCountry) {
    return null;
  }

  return mapCountryNameToCode(rawCountry);
}

function getTaxExtras() {
  const isLoggedIn = window.Convermax.BigCommerce?.isLoggedIn === true;

  return {
    country: isLoggedIn ? getCountry() || 'DE' : 'DE',
    rawTaxCountry: isLoggedIn ? window.Convermax.country || 'DE' : 'DE',
    customerGroupId: getCustomerGroupId(),
    customerGroupName: getCustomerGroupName(),
    isLoggedIn,
    lang: getLang(),
    isGrossRetailGroup: isGrossRetailGroup(),
    enableForumGrossMsrp: false,
    defaultTaxZone: 'DE',
  };
}

// Client Request: Clicking "All Products" in the nav bar should also redirect to the same vehicle landing page.
// If the selected vehicle has no landing page or the vehicle is discarded, restore the original link
function responseHandler(response) {
  const { vehicleLandingUrl } = response.Extra;
  const navBarAllProducts = window.document.querySelectorAll('a.navPages-action[aria-label="All Products"]');

  if (navBarAllProducts.length > 0) {
    navBarAllProducts.forEach((navItem) => {
      if (!navItem.dataset.originalHref) {
        navItem.dataset.originalHref = navItem.getAttribute('href') || navItem.href;
      }

      navItem.href = vehicleLandingUrl
        ? window.Convermax.getVehicleUrl(vehicleLandingUrl)
        : navItem.dataset.originalHref;
    });
  }

  return response;
}

export default {
  ...baseStoreDefaults,
  includes: ['2w37mf1yxr-1'],
  responseHandler,
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  getLocalPreselection,
  SearchRequestDefaults: {
    ...baseStoreDefaults.SearchRequestDefaults,
    extra: {
      ...baseStoreDefaults.SearchRequestDefaults.extra,
      ...getTaxExtras(),
      currency: '',
    },
  },
  getSearchRequestDefaults: (pageType) => {
    return {
      extra: {
        pageType,
        ...getTaxExtras(),
      },
    };
  },
  autocomplete: {
    ...baseStoreDefaults.autocomplete,
    requestDefaults: {
      ...baseStoreDefaults.autocomplete.requestDefaults,
      extra: {
        ...baseStoreDefaults.autocomplete.requestDefaults.extra,
        ...getTaxExtras(),
        currency: '',
      },
    },
  },
  fitmentSearch: {
    ...baseStoreDefaults.fitmentSearch,
    categorySelectionPageRedirect: false,
  },
  Widgets: [
    ...baseStoreDefaults.Widgets.filter((w) => !['SearchResult'].includes(w.name)),
    {
      name: 'SearchResult',
      updateCallback,
    },
  ],
};
